import { QUICKLINK_ACTION_TYPE } from "./quicklink.action";

export const quicklinkMessageContext = {
	get: QUICKLINK_ACTION_TYPE.get,
};
